import {TimeZone} from '../../../domain/models/timezone';
import {logger} from '../misc/logger';

const strictDatePattern = new RegExp('^(\\d{4})-(\\d{2})-(\\d{2})$');
const timePattern = new RegExp('^(\\d{2}):(\\d{2})$');

// date format is yyyy-mm-dd
// time format is hh:mm
export function makeTime(date: string,
                         time: string,
                         timeZone?: TimeZone): number | null {
  logger.log('makeTime', 'date', date, 'time', time);

  let year, month, day, hour, minute: number;

  let dateParts = strictDatePattern.exec(date);
  if (dateParts == null)
    return null;
  year = parseInt(dateParts[1], 10);
  month = parseInt(dateParts[2], 10);
  day = parseInt(dateParts[3], 10);
  if (month === 0 || month > 12)
    return null;

  let tmp = new Date(year, month - 1, day);
  if (tmp.getFullYear() !== year ||
    tmp.getMonth() !== (month - 1) ||
    tmp.getDate() !== day)
    return null;

  if (!timePattern.test(time))
    return null;

  hour = parseInt(time.substring(0, 2), 10);
  minute = parseInt(time.substring(3, 5), 10);
  if (hour > 23)
    return null;
  if (minute > 59)
    return null;

  let result = Date.UTC(year, month - 1, day, hour, minute) / 1000;
  if (timeZone !== undefined)
    result -= timeZone.UtcOffsetMinutes * 60;
  return result;
}
